import axios from "axios";

const url = process.env.REACT_APP_API_URL_HONEST
const contentType = 'application/json'

export default class HonestService {

    cekHaccp(nomorHaccp){
        let par1 = 'ff8f44c181153adbe4d12d1cf2fdde2e'
        let par2 = 'GETDATA-HACCPKKP'
        let jsonData = {
            'par1' : par1,
            'par2' : par2,
            'par3' : nomorHaccp
        }
        let data = JSON.stringify(jsonData)
        console.log(data)

        return axios.post(url + '/api_cekhaccp.php', data, {
            headers: {
                'Content-Type' : contentType
            },
        })
    }
    cekprimer(nomorPrimer){
        let par1 = 'e5041816ded49b5874bfdadbcde503d1'
        let par2 = 'GETDATA-PRIMER'
        let jsonData = {
            'par1' : par1,
            'par2' : par2,
            'par3' : nomorPrimer
        }
        let data = JSON.stringify(jsonData)
        console.log(data)

        return axios.post(url + '/api_cek_primer.php', data, {
            headers: {
                'Content-Type' : contentType
            },
        })
    }
    cekskp(nomorSKP){
        let par1 = '6e25b1f61faba2f8996e3d70c047ea77'
        let par2 = 'GETDATA-SKP'
        let jsonData = {
            'par1' : par1,
            'par2' : par2,
            'par3' : nomorSKP
        }
        let data = JSON.stringify(jsonData)
        console.log(data)

        return axios.post(url + '/api_cek_skp.php', data, {
            headers: {
                'Content-Type' : contentType
            },
        })
    }
    cekkapal(nomorKapal){
        let par1 = '660ffa8149fc706da5af82c6f50c15f5'
        let par2 = 'GETDATA-KAPAL'
        let jsonData = {
            'par1' : par1,
            'par2' : par2,
            'par3' : nomorKapal
        }
        let data = JSON.stringify(jsonData)
        console.log(data)

        return axios.post(url + '/api_cek_kapal.php', data, {
            headers: {
                'Content-Type' : contentType
            },
        })
    }
}